import {DeviceActionType} from '../types';

export const AVAILABLE_OPERATORS = ['AND', 'OR'];

export enum CompareOperator {
	equal = 'EQUAL',
	not = 'NOT'
}
export const MAX_TRIGGER_CONDITIONS = 3;
export const MAX_CONDITIONS = 30;
export const MAX_ACTIONS = 10;

export const OPERATOR_OR = AVAILABLE_OPERATORS[1];
export const OPERATOR_AND = AVAILABLE_OPERATORS[0];

export const ASSET_TYPE_PROPERTY = 'type';
export const COLOR_BLACK = '#000000';
export const COLOR_PALETTE = ['#FFFFFF', '#0000FF', '#00FF00', '#FF0000', '#00FFFF', '#FF00FF', '#FFFF00', COLOR_BLACK];

export const BLINKING_FREQUENCY = 1000;

export enum ValueType {
	color = 'color',
	frequency = 'frequency',
	operatingMode = 'operatingMode',
	text = 'text',
	outputState = 'outputstate',
	inputState = 'inputstate',
	boolean = 'boolean',
	unknown = 'unknown',
	empty = ''
}

export enum DeviceType {
	sBox = 'sBox',
	sLight = 'sLight',
	kisIo = 'kisIo'
}

export const EVENTS = {
	button1Pressed: 'button1pressed',
	button1released: 'button1released',
	button2Pressed: 'button2pressed',
	button2released: 'button2released'
};

export const ACTION_TYPE_EMAIL = 'EMAIL_ACTION';
export const ACTION_TYPE_DEVICE = 'DEVICE_ACTION';
export const ACTION_TYPE_WEBSOCKET = 'WEBSOCKET_ACTION';

export const DEVICE_ACTION_TYPE = {
	SET_LED: 'setLed' as DeviceActionType,
	SET_GPIO: 'setPin' as DeviceActionType
};

export const GPIO_ACTION_VALUE = {
	HIGH: 'true',
	LOW: 'false'
};

export const flashingCheckBoxMessage = {
	id: 'ruleengine.elementtarget.checkbox.flashing',
	defaultValue: 'Flashing'
};

export const AUTHORITY_UPDATE_RULE = 'UPDATE_RULE';
export const AUTHORITY_CREATE_RULE = 'CREATE_RULE';
export const AUTHORITY_DELETE_RULE = 'DELETE_RULE';
export const AUTHORITY_READ_RULE = 'READ_RULE';
export const AUTHORITY_READ_NOTIFICATION_TEMPLATE = 'READ_NOTIFICATION_TEMPLATE';

export const COUNTER_TRIGGER_MIN_VALUE = 2;
// eslint-disable-next-line @typescript-eslint/no-loss-of-precision
export const COUNTER_TRIGGER_MAX_VALUE = 9223372036854775807;
export const DURATION_TRIGGER_MIN_VALUE = 1;
export const DURATION_TRIGGER_MAX_VALUE = 30 * 24 * 60;
